import { render, staticRenderFns } from "./MainGroupView.vue?vue&type=template&id=345e24b0&"
import script from "./MainGroupView.vue?vue&type=script&lang=js&"
export * from "./MainGroupView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports